import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';

const AGENCY_EMAIL = 'brandi@brandiherrman.com';
const TEAL = '#2C4A52';
const CORAL = '#FF6B6B';
const CREAM = '#FFFDF9';
const DARK = '#2D3436';
const GRAY = '#636E72';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showReset, setShowReset] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [resetEmail, setResetEmail] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message);
    setLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
      redirectTo: window.location.origin
    });
    if (error) setError(error.message);
    else setResetSent(true);
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: TEAL, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px', letterSpacing: '2px', textTransform: 'uppercase', margin: '0 0 12px' }}>Client Portal</p>
          <h1 style={{ fontFamily: 'Georgia, serif', fontSize: '42px', color: 'white', margin: '0 0 8px', lineHeight: 1.1 }}>Content on Cue</h1>
          <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '15px', margin: 0 }}>Strategic content. Without the scramble.</p>
        </div>
        <div style={{ background: 'white', borderRadius: '24px', padding: '36px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
          {!showReset ? (
            <form onSubmit={handleLogin}>
              <div style={{ marginBottom: '18px' }}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: GRAY, marginBottom: '8px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@yourbusiness.com" required
                  style={{ width: '100%', boxSizing: 'border-box', border: '2px solid #E9ECEF', borderRadius: '12px', padding: '13px 16px', fontSize: '15px', outline: 'none', color: DARK }} />
              </div>
              <div style={{ marginBottom: '8px' }}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: GRAY, marginBottom: '8px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required
                  style={{ width: '100%', boxSizing: 'border-box', border: '2px solid #E9ECEF', borderRadius: '12px', padding: '13px 16px', fontSize: '15px', outline: 'none', color: DARK }} />
              </div>
              <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                <button type="button" onClick={() => { setShowReset(true); setResetEmail(email); }}
                  style={{ background: 'none', border: 'none', color: CORAL, fontSize: '13px', cursor: 'pointer', padding: 0 }}>
                  Forgot password?
                </button>
              </div>
              {error && <div style={{ background: '#FFE3E3', color: CORAL, borderRadius: '12px', padding: '12px 16px', fontSize: '13px', marginBottom: '18px' }}>{error}</div>}
              <button type="submit" disabled={loading}
                style={{ width: '100%', background: CORAL, color: 'white', border: 'none', borderRadius: '30px', padding: '15px', fontSize: '15px', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            </form>
          ) : resetSent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '40px', marginBottom: '16px' }}>📧</div>
              <h3 style={{ fontFamily: 'Georgia, serif', color: DARK, marginBottom: '8px' }}>Check your email</h3>
              <p style={{ color: GRAY, fontSize: '14px', marginBottom: '24px' }}>We sent a password reset link to <strong>{resetEmail}</strong></p>
              <button onClick={() => { setShowReset(false); setResetSent(false); }}
                style={{ background: 'none', border: 'none', color: CORAL, fontSize: '14px', cursor: 'pointer', fontWeight: '600' }}>
                ← Back to sign in
              </button>
            </div>
          ) : (
            <form onSubmit={handleReset}>
              <h3 style={{ fontFamily: 'Georgia, serif', color: DARK, margin: '0 0 8px' }}>Reset your password</h3>
              <p style={{ color: GRAY, fontSize: '13px', marginBottom: '20px' }}>Enter your email and we'll send you a reset link.</p>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: GRAY, marginBottom: '8px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>Email</label>
                <input type="email" value={resetEmail} onChange={e => setResetEmail(e.target.value)} placeholder="you@yourbusiness.com" required
                  style={{ width: '100%', boxSizing: 'border-box', border: '2px solid #E9ECEF', borderRadius: '12px', padding: '13px 16px', fontSize: '15px', outline: 'none', color: DARK }} />
              </div>
              {error && <div style={{ background: '#FFE3E3', color: CORAL, borderRadius: '12px', padding: '12px 16px', fontSize: '13px', marginBottom: '18px' }}>{error}</div>}
              <button type="submit" disabled={loading}
                style={{ width: '100%', background: CORAL, color: 'white', border: 'none', borderRadius: '30px', padding: '15px', fontSize: '15px', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, marginBottom: '12px' }}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <button type="button" onClick={() => setShowReset(false)}
                style={{ width: '100%', background: 'none', border: '2px solid #E9ECEF', borderRadius: '30px', padding: '14px', fontSize: '14px', cursor: 'pointer', color: GRAY }}>
                ← Back to sign in
              </button>
            </form>
          )}
        </div>
        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.4)', fontSize: '12px', marginTop: '24px' }}>contentoncue.com</p>
      </div>
    </div>
  );
}

function NavBar({ badge, welcome, onSignOut, tabs, activeTab, setActiveTab }) {
  return (
    <div style={{ background: TEAL, padding: '0 24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '12px', paddingBottom: '12px' }}>
        <img src="/logo.png" alt="Content on Cue" style={{ height: '64px', objectFit: 'contain' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {welcome && <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>Welcome, {welcome}</span>}
          {badge && <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px' }}>{badge}</span>}
          <button onClick={onSignOut} style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '20px', padding: '7px 16px', cursor: 'pointer', fontSize: '13px', color: 'white' }}>Sign out</button>
        </div>
      </div>
      {tabs && (
        <div style={{ display: 'flex', gap: '4px' }}>
          {tabs.map(tab => (
            <button key={tab} onClick={() => setActiveTab(tab)}
              style={{ background: activeTab === tab ? 'white' : 'transparent', color: activeTab === tab ? TEAL : 'rgba(255,255,255,0.7)', border: 'none', borderRadius: '8px 8px 0 0', padding: '8px 20px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
              {tab}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function AgencyResponses() {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [sortCol, setSortCol] = useState('received_at');
  const [sortDir, setSortDir] = useState('desc');

  useEffect(() => {
    supabase.from('client_response_details').select('*').order('received_at', { ascending: false })
      .then(({ data }) => { setResponses(data || []); setLoading(false); });
  }, []);

  const handleSort = (col) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir('asc'); }
  };

  const colMap = { 'Business': 'business_name', 'Contact': 'contact_name', 'Prompt': 'prompt_text', 'Response': 'message_text', 'Date': 'received_at' };

  const filtered = responses
    .filter(r => !search || Object.values(r).some(v => v?.toString().toLowerCase().includes(search.toLowerCase())))
    .sort((a, b) => {
      const av = a[sortCol] || ''; const bv = b[sortCol] || '';
      return sortDir === 'asc' ? av.toString().localeCompare(bv.toString()) : bv.toString().localeCompare(av.toString());
    });

  const SortIcon = ({ col }) => {
    const key = colMap[col];
    if (sortCol !== key) return <span style={{ color: 'rgba(0,0,0,0.2)', marginLeft: '4px' }}>↕</span>;
    return <span style={{ marginLeft: '4px' }}>{sortDir === 'asc' ? '↑' : '↓'}</span>;
  };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', color: GRAY }}>Loading responses...</div>;

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '20px', display: 'flex', gap: '12px', alignItems: 'center' }}>
        <input placeholder="Search all responses..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ border: '2px solid #E9ECEF', borderRadius: '12px', padding: '10px 16px', fontSize: '14px', outline: 'none', width: '320px' }} />
        <span style={{ color: GRAY, fontSize: '13px' }}>{filtered.length} responses</span>
      </div>
      <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #F1F3F5', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: '#F8F9FA', borderBottom: '2px solid #E9ECEF' }}>
              {['Business', 'Contact', 'Prompt', 'Response', 'Media', 'Date'].map(h => (
                <th key={h} onClick={() => colMap[h] && handleSort(colMap[h])}
                  style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '600', color: GRAY, fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase', cursor: colMap[h] ? 'pointer' : 'default', userSelect: 'none' }}>
                  {h}{colMap[h] && <SortIcon col={h} />}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((r, i) => (
              <tr key={r.id || i} style={{ borderBottom: '1px solid #F1F3F5', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                <td style={{ padding: '12px 16px', fontWeight: '600', color: DARK }}>{r.business_name || '—'}</td>
                <td style={{ padding: '12px 16px', color: DARK }}>{r.contact_name || '—'}</td>
                <td style={{ padding: '12px 16px', color: GRAY, maxWidth: '220px', whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.4' }}>
                  {r.prompt_text || '—'}
                </td>
                <td style={{ padding: '12px 16px', color: DARK, maxWidth: '220px', whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.4' }}>
                  {r.message_text || '—'}
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <MediaThumbs row={r} />
                </td>
                <td style={{ padding: '12px 16px', color: GRAY, whiteSpace: 'nowrap' }}>
                  {r.received_at ? new Date(r.received_at).toLocaleDateString() : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && <div style={{ padding: '40px', textAlign: 'center', color: GRAY }}>No responses found.</div>}
      </div>
    </div>
  );
}

// Expands responses with multiple images (media_urls) into one gallery item per image.
// Falls back to the single media_url when media_urls is empty.
function expandMedia(rows) {
  const out = [];
  for (const row of rows) {
    const list = (row.media_urls && row.media_urls.trim())
      ? row.media_urls.split(',').map(u => u.trim()).filter(Boolean)
      : (row.media_url ? [row.media_url] : []);
    for (const url of list) {
      out.push({ ...row, media_url: url });
    }
  }
  return out;
}

// Renders a strip of clickable thumbnails for a response's images.
// Uses media_urls (all images) when present, falls back to media_url.
function MediaThumbs({ row }) {
  const urls = (row.media_urls && row.media_urls.trim())
    ? row.media_urls.split(',').map(u => u.trim()).filter(Boolean)
    : (row.media_url ? [row.media_url] : []);
  if (urls.length === 0) return '\u2014';
  return (
    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
      {urls.map((url, i) => {
        const isImage = /\.(jpg|jpeg|png|webp|gif)$/i.test(url);
        return (
          <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            {isImage ? (
              <img src={url} alt="" style={{ width: '36px', height: '36px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #F1F3F5', display: 'block' }} />
            ) : (
              <span style={{ color: CORAL, fontWeight: '600', fontSize: '12px' }}>View</span>
            )}
          </a>
        );
      })}
    </div>
  );
}

function AgencyMedia() {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('client_response_details').select('*').not('media_url', 'is', null).neq('media_url', '').order('received_at', { ascending: false })
      .then(({ data }) => { setMedia(expandMedia(data || [])); setLoading(false); });
  }, []);

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', color: GRAY }}>Loading media...</div>;

  const images = media.filter(m => m.media_url?.match(/\.(jpg|jpeg|png|webp|gif)$/i));
  const videos = media.filter(m => m.media_url?.match(/\.(mp4|mov|avi|webm)$/i));
  const other = media.filter(m => m.media_url && !m.media_url.match(/\.(jpg|jpeg|png|webp|gif|mp4|mov|avi|webm)$/i));

  const GallerySection = ({ title, items, type }) => (
    <div style={{ marginBottom: '40px' }}>
      <h2 style={{ fontFamily: 'Georgia, serif', color: DARK, fontSize: '20px', marginBottom: '16px' }}>
        {title} <span style={{ color: GRAY, fontSize: '14px', fontWeight: 'normal' }}>({items.length})</span>
      </h2>
      {items.length === 0 ? <p style={{ color: GRAY, fontSize: '14px' }}>None yet.</p> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px' }}>
          {items.map((m, i) => (
            <a key={i} href={m.media_url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #F1F3F5', overflow: 'hidden' }}>
                {type === 'image' ? (
                  <img src={m.media_url} alt="" style={{ width: '100%', height: '160px', objectFit: 'cover', display: 'block' }} />
                ) : type === 'video' ? (
                  <div style={{ width: '100%', height: '160px', background: TEAL, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ color: 'white', fontSize: '40px' }}>▶</span>
                  </div>
                ) : (
                  <div style={{ width: '100%', height: '160px', background: '#F8F9FA', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontSize: '40px' }}>📎</span>
                  </div>
                )}
                <div style={{ padding: '10px 12px' }}>
                  <p style={{ margin: 0, fontSize: '12px', fontWeight: '600', color: DARK }}>{m.business_name || '—'}</p>
                  <p style={{ margin: '2px 0 0', fontSize: '11px', color: GRAY }}>{m.contact_name || '—'}</p>
                  <p style={{ margin: '2px 0 0', fontSize: '11px', color: GRAY }}>{m.received_at ? new Date(m.received_at).toLocaleDateString() : '—'}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div style={{ padding: '24px' }}>
      <GallerySection title="Photos" items={images} type="image" />
      <GallerySection title="Videos" items={videos} type="video" />
      {other.length > 0 && <GallerySection title="Other Files" items={other} type="other" />}
    </div>
  );
}

function AgencyClients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('clients').select('*').order('created_at', { ascending: false })
      .then(({ data }) => { setClients(data || []); setLoading(false); });
  }, []);

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', color: GRAY }}>Loading clients...</div>;

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #F1F3F5', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: '#F8F9FA', borderBottom: '2px solid #E9ECEF' }}>
              {['Business', 'Email', 'Status', 'Plan', 'Slug', 'Created'].map(h => (
                <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '600', color: GRAY, fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {clients.map((c, i) => (
              <tr key={c.id} style={{ borderBottom: '1px solid #F1F3F5', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                <td style={{ padding: '12px 16px', fontWeight: '600', color: DARK }}>{c.business_name || '—'}</td>
                <td style={{ padding: '12px 16px', color: GRAY }}>{c.email || '—'}</td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{ background: c.status === 'active' ? '#A8E6CF' : c.status === 'trial' ? '#FFE3E3' : '#E9ECEF', color: c.status === 'active' ? '#1a7a50' : c.status === 'trial' ? CORAL : GRAY, padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>
                    {c.status || '—'}
                  </span>
                </td>
                <td style={{ padding: '12px 16px', color: GRAY }}>{c.plan || '—'}</td>
                <td style={{ padding: '12px 16px', color: GRAY, fontFamily: 'monospace', fontSize: '12px' }}>{c.slug || '—'}</td>
                <td style={{ padding: '12px 16px', color: GRAY }}>{c.created_at ? new Date(c.created_at).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {clients.length === 0 && <div style={{ padding: '40px', textAlign: 'center', color: GRAY }}>No clients found.</div>}
      </div>
    </div>
  );
}

function ClientResponses({ clientId }) {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [sortCol, setSortCol] = useState('received_at');
  const [sortDir, setSortDir] = useState('desc');

  useEffect(() => {
    supabase.from('client_response_details').select('*')
      .eq('client_id', clientId)
      .order('received_at', { ascending: false })
      .then(({ data }) => { setResponses(data || []); setLoading(false); });
  }, [clientId]);

  const handleSort = (col) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir('asc'); }
  };

  const colMap = { 'Contact': 'contact_name', 'Prompt': 'prompt_text', 'Response': 'message_text', 'Date': 'received_at' };

  const filtered = responses
    .filter(r => !search || Object.values(r).some(v => v?.toString().toLowerCase().includes(search.toLowerCase())))
    .sort((a, b) => {
      const av = a[sortCol] || ''; const bv = b[sortCol] || '';
      return sortDir === 'asc' ? av.toString().localeCompare(bv.toString()) : bv.toString().localeCompare(av.toString());
    });

  const SortIcon = ({ col }) => {
    const key = colMap[col];
    if (sortCol !== key) return <span style={{ color: 'rgba(0,0,0,0.2)', marginLeft: '4px' }}>↕</span>;
    return <span style={{ marginLeft: '4px' }}>{sortDir === 'asc' ? '↑' : '↓'}</span>;
  };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', color: GRAY }}>Loading your responses...</div>;

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '20px', display: 'flex', gap: '12px', alignItems: 'center' }}>
        <input placeholder="Search responses..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ border: '2px solid #E9ECEF', borderRadius: '12px', padding: '10px 16px', fontSize: '14px', outline: 'none', width: '280px' }} />
        <span style={{ color: GRAY, fontSize: '13px' }}>{filtered.length} responses</span>
      </div>
      <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #F1F3F5', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: '#F8F9FA', borderBottom: '2px solid #E9ECEF' }}>
              {['Contact', 'Prompt', 'Response', 'Media', 'Date'].map(h => (
                <th key={h} onClick={() => colMap[h] && handleSort(colMap[h])}
                  style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '600', color: GRAY, fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase', cursor: colMap[h] ? 'pointer' : 'default', userSelect: 'none' }}>
                  {h}{colMap[h] && <SortIcon col={h} />}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((r, i) => (
              <tr key={r.id || i} style={{ borderBottom: '1px solid #F1F3F5', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                <td style={{ padding: '12px 16px', color: DARK }}>{r.contact_name || '—'}</td>
                <td style={{ padding: '12px 16px', color: GRAY, maxWidth: '220px', whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.4' }}>
                  {r.prompt_text || '—'}
                </td>
                <td style={{ padding: '12px 16px', color: DARK, maxWidth: '220px', whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.4' }}>
                  {r.message_text || '—'}
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <MediaThumbs row={r} />
                </td>
                <td style={{ padding: '12px 16px', color: GRAY, whiteSpace: 'nowrap' }}>
                  {r.received_at ? new Date(r.received_at).toLocaleDateString() : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && (
          <div style={{ padding: '60px 40px', textAlign: 'center' }}>
            <p style={{ color: DARK, fontFamily: 'Georgia, serif', fontSize: '18px', marginBottom: '8px' }}>No responses yet</p>
            <p style={{ color: GRAY, fontSize: '14px' }}>Your responses will appear here once you start replying to your prompts.</p>
          </div>
        )}
      </div>
    </div>
  );
}

function ClientMedia({ clientId }) {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('client_response_details').select('*')
      .eq('client_id', clientId)
      .not('media_url', 'is', null)
      .neq('media_url', '')
      .order('received_at', { ascending: false })
      .then(({ data }) => { setMedia(expandMedia(data || [])); setLoading(false); });
  }, [clientId]);

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', color: GRAY }}>Loading your media...</div>;

  const images = media.filter(m => m.media_url?.match(/\.(jpg|jpeg|png|webp|gif)$/i));
  const videos = media.filter(m => m.media_url?.match(/\.(mp4|mov|avi|webm)$/i));

  const GallerySection = ({ title, items, type }) => (
    <div style={{ marginBottom: '40px' }}>
      <h2 style={{ fontFamily: 'Georgia, serif', color: DARK, fontSize: '20px', marginBottom: '16px' }}>
        {title} <span style={{ color: GRAY, fontSize: '14px', fontWeight: 'normal' }}>({items.length})</span>
      </h2>
      {items.length === 0 ? <p style={{ color: GRAY }}>None yet.</p> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '16px' }}>
          {items.map((m, i) => (
            <a key={i} href={m.media_url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #F1F3F5', overflow: 'hidden' }}>
                {type === 'image' ? (
                  <img src={m.media_url} alt="" style={{ width: '100%', height: '150px', objectFit: 'cover', display: 'block' }} />
                ) : (
                  <div style={{ width: '100%', height: '150px', background: TEAL, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ color: 'white', fontSize: '36px' }}>▶</span>
                  </div>
                )}
                <div style={{ padding: '10px 12px' }}>
                  <p style={{ margin: 0, fontSize: '11px', color: GRAY }}>{m.contact_name || '—'}</p>
                  <p style={{ margin: '2px 0 0', fontSize: '11px', color: GRAY }}>{m.received_at ? new Date(m.received_at).toLocaleDateString() : '—'}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );

  if (media.length === 0) return (
    <div style={{ padding: '60px 40px', textAlign: 'center' }}>
      <p style={{ color: DARK, fontFamily: 'Georgia, serif', fontSize: '18px', marginBottom: '8px' }}>No media yet</p>
      <p style={{ color: GRAY, fontSize: '14px' }}>Photos and videos you share will appear here.</p>
    </div>
  );

  return (
    <div style={{ padding: '24px' }}>
      <GallerySection title="Photos" items={images} type="image" />
      <GallerySection title="Videos" items={videos} type="video" />
    </div>
  );
}

function AgencyDashboard({ user, onSignOut }) {
  const [activeTab, setActiveTab] = useState('Responses');
  return (
    <div style={{ minHeight: '100vh', background: CREAM }}>
      <NavBar welcome="Brandi" badge="Agency View" onSignOut={onSignOut} tabs={['Responses', 'Media', 'Clients']} activeTab={activeTab} setActiveTab={setActiveTab} />
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {activeTab === 'Responses' && <AgencyResponses />}
        {activeTab === 'Media' && <AgencyMedia />}
        {activeTab === 'Clients' && <AgencyClients />}
      </div>
    </div>
  );
}

function ClientDashboard({ user, onSignOut }) {
  const [activeTab, setActiveTab] = useState('My Responses');
  const [clientId, setClientId] = useState(null);
  const [clientName, setClientName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('clients').select('id, business_name').eq('email', user.email).single()
      .then(({ data }) => {
        if (data) { setClientId(data.id); setClientName(data.business_name); }
        setLoading(false);
      });
  }, [user.email]);

  if (loading) return (
    <div style={{ minHeight: '100vh', background: TEAL, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: 'white', fontFamily: 'Georgia, serif', fontSize: '18px' }}>Loading...</p>
    </div>
  );

  if (!clientId) return (
    <div style={{ minHeight: '100vh', background: CREAM }}>
      <NavBar onSignOut={onSignOut} />
      <div style={{ maxWidth: '600px', margin: '60px auto', padding: '0 24px', textAlign: 'center' }}>
        <h2 style={{ fontFamily: 'Georgia, serif', color: DARK }}>Account not found</h2>
        <p style={{ color: GRAY }}>Your account email doesn't match a client record. Please contact brandi@brandiherrman.com for help.</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: CREAM }}>
      <NavBar welcome={clientName} onSignOut={onSignOut} tabs={['My Responses', 'My Media']} activeTab={activeTab} setActiveTab={setActiveTab} />
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {activeTab === 'My Responses' && <ClientResponses clientId={clientId} />}
        {activeTab === 'My Media' && <ClientMedia clientId={clientId} />}
      </div>
    </div>
  );
}

function SetNewPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.updateUser({ password });
    if (error) setError(error.message);
    else setDone(true);
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: TEAL, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <img src="/logo.png" alt="Content on Cue" style={{ height: '56px', objectFit: 'contain', marginBottom: '16px' }} />
          <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '15px', margin: 0 }}>Set your new password</p>
        </div>
        <div style={{ background: 'white', borderRadius: '24px', padding: '36px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
          {done ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '40px', marginBottom: '16px' }}>✅</div>
              <h3 style={{ fontFamily: 'Georgia, serif', color: DARK, marginBottom: '8px' }}>Password updated!</h3>
              <p style={{ color: GRAY, fontSize: '14px', marginBottom: '24px' }}>You can now sign in with your new password.</p>
              <button onClick={() => { supabase.auth.signOut(); window.location.href = '/'; }}
                style={{ background: CORAL, color: 'white', border: 'none', borderRadius: '30px', padding: '12px 24px', fontSize: '14px', fontWeight: '700', cursor: 'pointer' }}>
                Go to Sign In
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '18px' }}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: GRAY, marginBottom: '8px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>New Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min. 8 characters" required
                  style={{ width: '100%', boxSizing: 'border-box', border: '2px solid #E9ECEF', borderRadius: '12px', padding: '13px 16px', fontSize: '15px', outline: 'none', color: DARK }} />
              </div>
              <div style={{ marginBottom: '24px' }}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: GRAY, marginBottom: '8px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>Confirm Password</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat your password" required
                  style={{ width: '100%', boxSizing: 'border-box', border: '2px solid #E9ECEF', borderRadius: '12px', padding: '13px 16px', fontSize: '15px', outline: 'none', color: DARK }} />
              </div>
              {error && <div style={{ background: '#FFE3E3', color: CORAL, borderRadius: '12px', padding: '12px 16px', fontSize: '13px', marginBottom: '18px' }}>{error}</div>}
              <button type="submit" disabled={loading}
                style={{ width: '100%', background: CORAL, color: 'white', border: 'none', borderRadius: '30px', padding: '15px', fontSize: '15px', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Updating...' : 'Set New Password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isRecovery, setIsRecovery] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => { setSession(session); setLoading(false); });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setSession(session);
      if (event === 'PASSWORD_RECOVERY') setIsRecovery(true);
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleSignOut = async () => {
    setIsRecovery(false);
    await supabase.auth.signOut();
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', background: TEAL, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: 'white', fontFamily: 'Georgia, serif', fontSize: '18px' }}>Loading...</p>
    </div>
  );

  if (!session) return <Login />;
  if (isRecovery) return <SetNewPassword />;
  if (session.user.email === AGENCY_EMAIL) return <AgencyDashboard user={session.user} onSignOut={handleSignOut} />;
  return <ClientDashboard user={session.user} onSignOut={handleSignOut} />;
}
